<template>
  <div>
    <u-menu v-if="classes.length > 3">
      <template #activator="{toggle}">
        <u-button class="w-36" @click="toggle">
          {{ selected || "Выберите класс" }}
        </u-button>
      </template>

      <u-card>
        <u-card-body>
          <router-link
            v-for="cl in classes"
            :key="cl.id"
            custom
            :to="{ name: 'request', params: { classId: cl.id } }"
            v-slot="{ navigate, isActive }"
          >
            <u-tab
              class="w-full my-1"
              @click="selectClass(cl)"
              :active="isActive"
            >
              {{ cl.number }}{{ cl.liter }} класс
            </u-tab>
          </router-link>
        </u-card-body>
      </u-card>
    </u-menu>

    <div v-else class="flex overflow-x-auto mr-4 flex-1">
      <router-link
        v-for="cl in classes"
        :key="cl.id"
        custom
        :to="{ name: 'request', params: { classId: cl.id } }"
        v-slot="{ navigate, isActive }"
      >
        <u-tab @click="selectClass(cl)" :active="isActive">
          {{ cl.number }}{{ cl.liter }}
        </u-tab>
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    selectedClassId: {
      type: [String, Number],
      default: null
    },
    classes: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      selected: ""
    };
  },

  watch: {
    selectedClassId: {
      handler(classId) {
        if (classId && this.classes.length > 0) {
          this.updateSelectedLabel(classId);
        }
      },
      immediate: true
    },

    classes: {
      handler(newClasses) {
        if (newClasses.length > 0 && this.selectedClassId) {
          this.updateSelectedLabel(this.selectedClassId);
        }
      },
      immediate: true
    }
  },

  methods: {
    updateSelectedLabel(classId) {
      const classItem = this.classes.find(c => c.id == classId);
      if (classItem) {
        this.selected = `${classItem.number}${classItem.liter} класс`;
        this.$emit("class-selected", classItem);
      }
    },

    selectClass(classItem) {
      this.selected = `${classItem.number}${classItem.liter} класс`;
      this.$emit("class-selected", classItem);
      this.$router.push({ name: "request", params: { classId: classItem.id } });
    }
  }
};
</script>
